import AmexShopSmallBuyout from './AmexShopSmallBuyout';

export default AmexShopSmallBuyout;
